var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmiley(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 137 121",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "white",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-23.137,-7.34755)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 92.184,
    cy: 66.597,
    r: 44.867,
    style: {
      fill: "transparent",
      stroke: "white",
      strokeWidth: "4.17px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M56,83.65C56,79.25 66,74.75 72.35,76.35C75.5,77.15 81,81.7 81,83.55C81,85.75 79.4,85.25 76.15,82C73.7,79.5 72.3,79 68.6,79C64.95,79 63.35,79.6 60.65,82C56.85,85.3 56,85.6 56,83.65Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92,73.8L92,69.45L87.75,69.75C76.2,70.55 68.85,58.7 74.3,48.25C79,39.3 94.9,39.1 99.45,47.95C102.2,53.25 100.45,66 97,66C96.5,66 95.95,68.55 95.75,71.7C95.55,76.25 95.1,77.55 93.75,77.8C92.3,78.05 92,77.4 92,73.8ZM92.25,65.9C100.85,61.95 99.4,47.1 90.15,44.45C87.9,43.8 87.85,43.95 88.5,48.3C89.55,55.3 84.05,59.25 77.8,55.9C75,54.4 74.6,55.25 76,59.5C78,65.65 85.95,68.75 92.25,65.9ZM85.55,51.45C86.65,47.15 82.2,44.15 79.15,47.2C76.5,49.85 78.6,54 82.65,54C84.25,54 85.1,53.25 85.55,51.45Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.25,72.25C37.55,72 36.95,70.15 36.95,68.15C36.95,66.15 36.25,62.55 35.45,60.15C30.4,45.7 49.1,34.5 59.7,45.65C69.7,56.2 60.85,71.55 45.85,69.55C41.95,69.05 41,69.2 41,70.4C41,72.15 39.95,72.85 38.25,72.25ZM54.9,65.5C63.45,61.1 61.75,47.4 52.25,44.55C50.15,43.9 50.1,44.05 50.65,48.8C51.45,55.65 46.05,59.25 39.9,55.95C38.3,55.05 38,55.25 38,57.05C38,64.7 47.4,69.4 54.9,65.5ZM46.8,53.1C48.6,51.95 47.9,47.95 45.75,46.6C42.25,44.4 38.35,49.3 41,52.5C42.35,54.15 44.8,54.4 46.8,53.1Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.45,32.95C50.15,32.4 50.45,31.8 51.15,31.6C56.95,30.05 58.6,29.15 59.45,27.2C60.6,24.65 63,24.2 63,26.55C63,31.05 52.55,36.35 50.45,32.95Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.05,31.4C77.35,29.95 76,27.95 76,26.9C76,24.15 77.25,24.5 79.8,28C81.4,30.15 82.85,31 85,31C87,31 88,31.5 88,32.5C88,34.95 82.5,34.3 79.05,31.4Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.296,66.723C94.278,66.759 93.541,77.277 93.517,77.277",
    style: {
      fill: "none",
      stroke: "rgb(47,234,233)",
      strokeWidth: "4.17px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.211,65.035C39.193,65.071 39.113,71.002 39.089,71.002",
    style: {
      fill: "none",
      stroke: "rgb(47,234,233)",
      strokeWidth: "4.17px"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmiley);
export default __webpack_public_path__ + "assets/media/smiley.c6d508fbaa9cf56611e7908ea240c275.svg";
export { ForwardRef as ReactComponent };